module.exports = __webpack_public_path__ + "static/fonts/Fact-SemiExpandedExtraBold.0d7aea5.eot";